import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const riskMaterialityLogService = createApi({
    reducerPath: 'riskMaterialityLogService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['RiskMaterialityLog'],
    endpoints: (builder) => ({
        getAllRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getRiskMaterialityLogById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        findAllRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadRiskMaterialityLog: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.riskMaterialityLogController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});

export const {
    useGetAllRiskMaterialityLogMutation,
    useSaveRiskMaterialityLogMutation,
    useUpdateRiskMaterialityLogMutation,
    useDeleteRiskMaterialityLogMutation,
    useGetRiskMaterialityLogByIdMutation,
    useFindAllRiskMaterialityLogMutation,
    useBulkUploadRiskMaterialityLogMutation,
} = riskMaterialityLogService;
